export default "/images/vendor/flag-icons/flags/4x3/tj.svg?7342efc96604d64ffb2c8eaf16b89451";